/*
 * @Author: zhengxiaowen
 * @Date: 2018-10-10 20:45:51
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-12-11 11:50:22
 */

import SaafHeader from './SaafHeader'
import SaafFooter from './SaafFooter'
import SaafContent from './SaafContent'
import SaafImageUpload from './SaafImageUpload'
import SaafScroller from './SaafScroller'
import PageContainer from './page/PageContainer'
import PageContent from './page/PageContent'
import PageFooter from './page/PageFooter'
import PageHeader from './page/PageHeader'

import Error404 from './Error404'

export {
    Error404,
    SaafHeader,
    SaafFooter,
    SaafImageUpload,
    SaafScroller,
    SaafContent,
    PageContainer,
    PageContent,
    PageFooter,
    PageHeader,
}



// WEBPACK FOOTER //
// ./src/common/components/index.js